import cloneDeep from "lodash/cloneDeep";
import { getUTCDate, isValidValue, replacePlaceholders, userFullName } from "./common";
import { ASSESSMENT_REPORT_V2_QUESTIONS, ATTENDANCE_QUESTION_IDS, CONSULTATION_PLANT_REPORT_QUESTIONS, GOAL_TRACK_PARAMETERS, TREATMENT_SUMMARY_REPORT_QUESTIONS } from "config/constants";
import moment from "moment";
import { trackerDefaultFields } from "config/reports";
import { isEmpty } from "lodash";

export const SINGLE_ASSESSMENT_PLAN_FIELD = {
  assessment_date: new Date(),
  title: "",
  description: "",
  summary: {
    answer: "",
    attachmentData: []
  },
  diagnosis_severity: {
    answer: "",
    attachmentData: []
  }
}

export const SINGLE_TREATMENT_PLAN_FIELD = {
  strategies: [{
    answer: "",
    attachmentData: []
  }]
}

export const getGoalTrackingPercentage = (parameter, goalTracking) => {
  let parameterOccurrence = goalTracking?.filter((tracking) => tracking.tracked === parameter);
  let parameterPercentage = (parameterOccurrence?.length / goalTracking?.length) * 100; // (value / totalValue) * 100;
  return !isNaN(parameterPercentage) ? Math.ceil(parameterPercentage) : 0;
}

export const getGoalTrackingCount = (parameter, goalTracking) => {
  let parameterOccurrence = goalTracking?.filter((tracking) => tracking.tracked === parameter);
  return {
    total: goalTracking?.length,
    occurrence: parameterOccurrence?.length,
  };
}

export const formatReportFeedback = (reportHeading, reportQuestions, values) => {
  let payload = {
    report_heading: reportHeading,
    documents: values?.documents,
    resources: values?.resources,
    assesment_location: values?.assesment_location,
    feedbacks: [],
  };

  if (!reportQuestions?.length) {
    return payload;
  }

  reportQuestions.forEach((question) => {
    if (values.hasOwnProperty(question.id)) {
      let filledData = values[question.id];
      let feedbackRow = {
        question_id: question.id,
        question_feedback: {
          answer: filledData.answer,
          other_details: filledData?.other_details || {}
        }
      }

      if (filledData?.other_details?.visibility !== undefined) {
        console.log("not undefined", filledData, question.question);
        feedbackRow.question_feedback.other_details.visibility = filledData.other_details.visibility ? "visible" : "hidden";
      }

      if (question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.goal_notes) {

      }
      else if (
        question.question_type === "textarea_radio"
      ) {
        // feedbackRow.question_feedback.other_details?.radio_tag = filledData.other_details.radio_tag;
      }
      else if (question.question_type === "textarea_dd") {
        feedbackRow.question_feedback.other_details.dd_labels = {
          name: filledData?.other_details?.dd_labels?.name?.value,
          description: filledData?.other_details?.dd_labels?.description,
        };
      }

      payload.feedbacks.push(feedbackRow);
    }
  });

  return payload;
}

export const formatReportFeedbackV2 = (reportHeading, reportQuestions, values) => {
  let payload = {
    report_heading: reportHeading,
    documents: values?.documents,
    resources: values?.resources,
    assesment_location: values?.assesment_location,
    feedbacks: [],
  };

  if (!reportQuestions?.length) {
    return payload;
  }

  reportQuestions.forEach((question) => {
    if (values.hasOwnProperty(question.id)) {
      let filledData = values[question.id];
      let feedbackRow = {
        question_id: question.id,
        question_feedback: {
          answer: filledData.answer,
          other_details: filledData?.other_details || {}
        }
      }

      if (filledData?.other_details?.visibility !== undefined) {
        console.log("not undefined", filledData, question.question);
        feedbackRow.question_feedback.other_details.visibility = filledData.other_details.visibility ? "visible" : "hidden";
      }

      if (question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.goal_notes) {

      }
      else if (
        question.question_type === "textarea_radio"
      ) {
        // feedbackRow.question_feedback.other_details?.radio_tag = filledData.other_details.radio_tag;
      }
      else if (question.question_type === "textarea_dd") {
        feedbackRow.question_feedback.other_details.dd_labels = {
          name: filledData?.other_details?.dd_labels?.name?.value,
          description: filledData?.other_details?.dd_labels?.description,
        };
      }

      payload.feedbacks.push(feedbackRow);
    }
  });

  return payload;
}

export const reportInitialValues = (initialValues, reportQuestions, answers) => {
  let values = cloneDeep(initialValues);

  reportQuestions.forEach((question, index) => {
    let foundAnswer = answers.find(answer => answer.question_id === question.id);
    let answer = foundAnswer?.answer;
    // if (!foundAnswer) {
    //   return;
    // }

    let answerOtherDetails = cloneDeep(answer?.other_details);
    let answerRow = {
      answer: answer?.answer || null,
      other_details: cloneDeep(answerOtherDetails) || {}
    }

    /**
     * Question visibility
     */
    if (question.visibility !== "default") {
      answerRow.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
      answerRow.other_details.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
    }

    if (typeof answerOtherDetails?.visibility !== "undefined") {
      answerRow.other_details.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
    }

    /**
     * Handle Treatment Summary chart data
     */
    if (
      question.question_type === "date" &&
      question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails = {
          attendance: {},
          selected_goals: [],
          chart_data: {},
        }
      }
      answerRow = {
        other_details: answerOtherDetails
      }
    }

    /**
     * Handle Treatment Summary Goal chart review notes
     */
    else if (
      question.question_type === "textarea_radio" &&
      question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.goal_notes
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails = {
          goal_notes: {},
        }
      }
      answerRow = {
        other_details: answerOtherDetails
      }
    }

    /**
     * Handle Textarea questions
     */
    else if (
      question.question_type === "textarea_radio"
    ) {
      // answerRow.radio_tag = answerOtherDetails?.radio_tag;
    }

    /**
     * Handle Dropdown questions
     */
    else if (question.question_type === "textarea_dd") {
      if (answerOtherDetails?.dd_labels?.name) {
        answerRow.other_details.dd_labels = {
          name: {
            value: answerOtherDetails?.dd_labels?.name,
            label: answerOtherDetails?.dd_labels?.name,
          },
          description: answerOtherDetails?.dd_labels?.description,
        };
      }
    }

    /**
     * Handle questions with templates
     */
    if (question.question_type === "template") {
      if (!answerRow.answer) {
        // let template = question.template;
        // const values = {
        //   THERAPIST_NAME: "Test",
        // };
        // let templateString = replacePlaceholders(template, values);
        // answerRow = {
        //   answer: question.template,
        // }
      }
    }

    else if (
      question.question_type === "tracker"
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails =
        {
          visibility: true,
          tracking: [
            cloneDeep(trackerDefaultFields)
          ]
        };
      }
      answerRow = {
        other_details: {
          ...answerOtherDetails,
          ...answerRow.other_details
        }
      }
      console.log("answerRow", answerRow)
    }

    if (ATTENDANCE_QUESTION_IDS.includes(question.id)) {
      if (!answerRow.answer) {
        answerRow.answer = "present";
      }
    }

    values[question.id] = answerRow;
  })

  return values;
}

export const reportInitialValuesV2 = (initialValues, reportQuestions, answers, data) => {
  let values = cloneDeep(initialValues);

  reportQuestions.forEach((question, index) => {

    let foundAnswer = answers?.length && answers.find(answer => answer.question_id === question.id);
    let answer = foundAnswer?.answer;
    // if (!foundAnswer) {
    //   return;
    // }

    let answerOtherDetails = cloneDeep(answer?.other_details);
    let answerRow = {
      answer: answer?.answer || null,
      other_details: cloneDeep(answerOtherDetails) || {}
    }

    /**
     * Question visibility
     */
    if (question.visibility !== "default") {
      answerRow.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
      answerRow.other_details.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
    }

    if (typeof answerOtherDetails?.visibility !== "undefined") {
      answerRow.other_details.visibility = answerOtherDetails?.visibility === "visible" ? true : false;
    }

    /**
     * Handle Treatment Summary chart data
     */
    if (
      question.question_type === "date" &&
      question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.treatment_summary
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails = {
          attendance: {},
          selected_goals: [],
          chart_data: {},
        }
      }
      answerRow = {
        other_details: answerOtherDetails
      }
    }

    /**
     * Handle Treatment Summary Goal chart review notes
     */
    else if (
      question.question_type === "textarea_radio" &&
      question.id === TREATMENT_SUMMARY_REPORT_QUESTIONS.goal_notes
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails = {
          goal_notes: {},
        }
      }
      answerRow = {
        other_details: answerOtherDetails
      }
    }

    /**
     * Handle Textarea questions
     */
    else if (
      question.question_type === "textarea_radio"
    ) {
      // answerRow.radio_tag = answerOtherDetails?.radio_tag;
    }

    /**
     * Handle Dropdown questions
     */
    else if (question.question_type === "textarea_dd") {
      if (answerOtherDetails?.dd_labels?.name) {
        answerRow.other_details.dd_labels = {
          name: {
            value: answerOtherDetails?.dd_labels?.name,
            label: answerOtherDetails?.dd_labels?.name,
          },
          description: answerOtherDetails?.dd_labels?.description,
        };
      }
    }

    /**
     * Handle questions with templates
     */
    if (question.question_type === "template") {
      if (!answerRow.answer) {
        // let template = question.template;
        // const values = {
        //   THERAPIST_NAME: "Test",
        // };
        // let templateString = replacePlaceholders(template, values);
        // answerRow = {
        //   answer: question.template,
        // }
      }
    }

    else if (
      question.question_type === "tracker"
    ) {
      if (!answerOtherDetails) {
        answerOtherDetails =
        {
          visibility: true,
          tracking: [
            cloneDeep(trackerDefaultFields)
          ]
        };
      }
      answerRow = {
        other_details: {
          ...answerOtherDetails,
          ...answerRow.other_details
        }
      }
      console.log("answerRow", answerRow)
    }

    if (ATTENDANCE_QUESTION_IDS.includes(question.id)) {
      if (!answerRow.answer) {
        answerRow.answer = "present";
      }
    }

    values[question.id] = answerRow;

    if (question.id === ASSESSMENT_REPORT_V2_QUESTIONS.assessment) {
      let assessments = cloneDeep(data?.assesmentData?.reportAssesmentTreatments);
      if (isEmpty(assessments)) {
        assessments = [];
      }
      values["assessment_plans"] = assessments;
    }

    if (question.id === ASSESSMENT_REPORT_V2_QUESTIONS.treatment_plan) {
      let treatments = data?.assesmentData?.reportGoalStrategies;
      if (isEmpty(treatments)) {
        treatments = [];
      }
      else {
        treatments = treatments?.map((item) => {
          const plan = {
            id: item?.id,
            assesment_id: item?.assesment_id,
            discipline_id: item?.discipline_id,
            area_id: item?.assesmentGoalStrategyArea?.name ? { value: item?.area_id, label: item?.assesmentGoalStrategyArea?.name } : "",
            goal_id: item?.assesmentGoalStrategyDetail?.title ? { value: item?.goal_id, label: item?.assesmentGoalStrategyDetail?.title } : "",
            goal_details: item?.goal_details || "",
            // assesmentGoalStrategyArea: {
            //   name: "Ergonomics and Universal Adaptations"
            // },
            // assesmentGoalStrategyDetail: {
            //   title: "Accesses Self-Care"
            // },
          }

          if (item?.AssessmentGoalStrategyData?.length) {
            plan.AssessmentGoalStrategyData = item?.AssessmentGoalStrategyData?.map((strategy) => {
              let attachmentData = [];
              try {
                attachmentData = strategy?.attachmentData
                  ? JSON.parse(strategy.attachmentData)
                  : [];
              } catch {
                attachmentData = [];
              }
  
              return {
                id: strategy?.id,
                answers: strategy?.answers,
                attachmentData,
                title: strategy?.TemplateDetail?.title,
                template_id: strategy?.template_id
              };
            })
          } else {
            plan.AssessmentGoalStrategyData = [{
              answers: "",
              attachmentData: []
            }]
          }
          
          return plan;
        })
      }
      values["treatment_plans"] = treatments;
    }

  })

  return values;
}


export const getTreatmentSummaryChartData_bak = (goal, goalSummary, enabledTrackParams) => {
  const dates = [];
  const series = [];

  goalSummary.forEach(row => {
    if (goal.goal_id !== row.goal_id) {
      return;
    }

    const date = getUTCDate(row.createdAt);
    let graphItem = {
      [date]: {}
    }

    Object.keys(GOAL_TRACK_PARAMETERS).map(param => {
      if (row.goalTracking?.length > 0) {
        row.goalTracking.forEach((item) => {
          if (item.tracked === param) {
            if (graphItem[date][param]) {
              graphItem[date][param] += 1;
            } else {
              graphItem[date][param] = 1
            }
          }
        })
        if (!graphItem[date][param]) {
          graphItem[date][param] = 0;
        }
      }
    })

    series.push(graphItem);
  })

  const chartData = {
    series: [],
    dates: []
  };

  const trackParams = {};
  // console.log("trackParams", trackParams);
  series.forEach(row => {
    const [date, tracking] = Object.entries(row)[0];
    chartData.dates.push(date);

    _.forEach(tracking, (count, param) => {
      if (!trackParams[param]) {
        trackParams[param] = [];
      }
      trackParams[param].push(count);
    });
  });

  _.forEach(enabledTrackParams, (value, param) => {
    if (!value) {
      return;
    }
    chartData.series.push({
      name: param,
      data: trackParams[param] || [0]
    });
  });

  return chartData
}

/**
 * Prepare chart data from the goal summary data received from API
 */
export const getTreatmentSummaryChartData = (goal, goalSummary, enabledTrackParams) => {
  const series = [];

  goalSummary.forEach(row => {
    if (goal.goal_id !== row.goal_id) {
      return;
    }

    const date = getUTCDate(row.createdAt);
    let graphItem = {
      [date]: {}
    }

    Object.keys(GOAL_TRACK_PARAMETERS).map(param => {
      if (row.goalTracking?.length > 0) {
        let totalTracked = row.goalTracking.length;
        let trackedParamCount = 0;
        row.goalTracking.forEach((item) => {
          if (item.tracked === param) {
            trackedParamCount += 1;
          }
        })
        graphItem[date][param] = Math.round((trackedParamCount * 100) / totalTracked);
      }
    })

    series.push(graphItem);
  })

  const chartData = {
    series: [],
    dates: []
  };

  const trackParams = {};
  // console.log("trackParams", trackParams);
  series.forEach(row => {
    const [date, tracking] = Object.entries(row)[0];
    chartData.dates.push(date);

    _.forEach(tracking, (count, param) => {
      if (!trackParams[param]) {
        trackParams[param] = [];
      }
      trackParams[param].push(count);
    });
  });

  _.forEach(enabledTrackParams, (value, param) => {
    if (!value) {
      return;
    }
    chartData.series.push({
      name: param,
      data: trackParams[param] || [0]
    });
  });

  return chartData
}

export const greetingFieldPlaceholders = (therapistDetails) => {
  return {
    THERAPIST_NAME: userFullName(therapistDetails?.caseTherapist),
    CLIENT_NAME: userFullName(therapistDetails?.clientDetail)
  }
}